import { ErrorHandler, Injectable, inject } from '@angular/core';
import { GlobalNotificationService } from './services/global-notification.service';

@Injectable()
export class AppErrorHandler implements ErrorHandler {
  private globalErrorHandler = inject(GlobalNotificationService);

  handleError(error: Error): void {
    // Let the global error handler service deal with it
    this.globalErrorHandler.handleError(error);
  }
}
